import { render, staticRenderFns } from "./web-detail.vue?vue&type=template&id=4435f6e4&scoped=true&"
import script from "./web-detail.vue?vue&type=script&lang=ts&"
export * from "./web-detail.vue?vue&type=script&lang=ts&"
import style0 from "./web-detail.vue?vue&type=style&index=0&id=4435f6e4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4435f6e4",
  null
  
)

export default component.exports